import React from "react";
import { StarIcon as Star } from "@phosphor-icons/react";

/**
 * Star row display. `value` is the avg (1.0–5.0); supports half-stars.
 * `size` is the Phosphor icon px size. Read-only.
 */
export default function StarRating({ value = 0, size = 14, className = "" }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${v.toFixed(1)} of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = v >= i;
        const half = !filled && v >= i - 0.5;
        return (
          <Star
            key={i}
            size={size}
            weight={filled ? "fill" : half ? "duotone" : "regular"}
            className={filled || half ? "text-amber-400" : "text-[#D8D5CC]"}
          />
        );
      })}
    </div>
  );
}
